import { useEffect, useRef } from 'react';
import axios from 'axios';
import { PrivatePayrollAuctionLoading } from '../Loading';

const POLL_INTERVAL_MS = 15000;
const POLL_TIMEOUT_MS = 120000;

type Props = {
    signerHash: string;
    setSignerStep: (step: string) => void;
    setSignData: (updater: (prev: any) => any) => void;
    clearAwaitingEnvelopeSubmit: () => void;
    pendingNextStep?: string;
};

export const PrivatePayrollAuctionAwaitingEnvelopeSubmit = (props: Props) => {
    const {
        signerHash,
        setSignerStep,
        setSignData,
        clearAwaitingEnvelopeSubmit,
        pendingNextStep,
    } = props;

    const stoppedRef = useRef(false);

    useEffect(() => {
        stoppedRef.current = false;

        const poll = async () => {
            if (stoppedRef.current) return;
            try {
                const response = await axios.get('/signer/hash/' + signerHash);
                if (stoppedRef.current) return;

                const data = response.data || {};
                setSignData((prev: any) => ({ ...prev, ...data }));

                if (data.next_step_blocked === false) {
                    stoppedRef.current = true;
                    const resumeStep = data.next_step || pendingNextStep;
                    clearAwaitingEnvelopeSubmit();
                    if (resumeStep) {
                        setSignerStep(resumeStep);
                    }
                }
            } catch {}
        };

        poll();
        const interval = setInterval(poll, POLL_INTERVAL_MS);
        const timeout = setTimeout(() => {
            stoppedRef.current = true;
            clearInterval(interval);
        }, POLL_TIMEOUT_MS);

        return () => {
            stoppedRef.current = true;
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [signerHash, setSignerStep, setSignData, clearAwaitingEnvelopeSubmit, pendingNextStep]);

    return <PrivatePayrollAuctionLoading />;
};
